// BS3 allowed tooltip + dropdown (etc.) on the same element; Bootstrap 5's
// internal Data registry allows a single component instance per element and
// logs "Bootstrap doesn't allow more than one instance per element" for the
// second one. Legacy markup relies on stacking components, so replace the
// registry with a per-(element, component) one. All dist components share this
// module instance and call Data.<method>() at runtime, so patching it here
// applies to every component.
import Data from 'bootstrap/js/dist/dom/data';

export function installMultiInstanceData() {
  const registry = new WeakMap();

  Data.set = (element, key, instance) => {
    if (!registry.has(element)) {registry.set(element, new Map());}
    registry.get(element).set(key, instance);
  };

  Data.get = (element, key) => registry.get(element)?.get(key) || null;

  Data.remove = (element, key) => {
    const instanceMap = registry.get(element);

    if (!instanceMap) {return;}
    instanceMap.delete(key);
    if (instanceMap.size === 0) {registry.delete(element);}
  };
}
